import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppRoutes from "./components/AppRoute/AppRoute";
import Loader from "./components/Loader/Loader";
import "./App.css";

function App() {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <ToastContainer />

 
      <Loader open={loading} />

      <AppRoutes setLoading={setLoading} />
    </>
  );
}

export default App;
